import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd89c086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "logo-mark" }, "Pf")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Planfree"),
  /*#__PURE__*/_createElementVNode("p", { class: "tagline" }, "Free planning poker for agile teams")
], -1))
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "loading-text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "spinner",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-dasharray": "31.4 31.4"
  })
], -1))

import router from "@/router";
import { io } from "socket.io-client";
import { ref, onMounted } from "vue";
import { useGameEngine } from "@/composables/useGameEngine";
import GameFormat from "@/view-models/gameFormat";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { socket, setSocket } = useGameEngine();
const clickedStart = ref(false);
const hasStarted = ref(false);

onMounted(() => {
  startGame();
})

function startGame() {
  clickedStart.value = true;
  setTimeout(() => {
    if (!hasStarted.value) {
      alert("Unable to connect to the server. Please check your internet connection or try again later.");
      clickedStart.value = false;
    }
  }, 6000);
  registerSocket();
}

function goToPrivacy() {
  router.push({ path: "/privacy" });
}

function registerSocket() {
  const newSocket = io(process.env.VUE_APP_SERVER);
  setSocket(newSocket);
  socket.value.on("room", (roomId: string) => {
    hasStarted.value = true;
    router.push({ path: `/game/${roomId}` });
  });
  socket.value.on("gameTypes", (gameTypes: GameFormat[]) => {
    localStorage.setItem("gameTypes", JSON.stringify(gameTypes));
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["button primary", { loading: clickedStart.value && !hasStarted.value }]),
          onClick: startGame,
          disabled: clickedStart.value
        }, [
          (!clickedStart.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Start new session"))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" Connecting... ")
              ]))
        ], 10, _hoisted_6)
      ]),
      _createElementVNode("p", {
        class: "privacy",
        onClick: goToPrivacy
      }, "Privacy Policy")
    ])
  ]))
}
}

})